<i18n
  src="@/locales/views/agro_exporter/production/query_container_quality/show_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container_final_quality.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_process')"
    :params="{
      agro_exporter_id: agro_exporter_id,
      agro_exporter_process_id: agro_exporter_process_id
    }"
  />

  <bread-crumbs :labels="[module_name, agro_exporter_process?.name]" />

  <template v-if="load_general_data">
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.container_code") }}
                </dt>
                <dd class="content-data">
                  {{ container.container_code }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.customer") }}
                </dt>
                <dd class="content-data">
                  {{ container.customer?.name }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.week") }}
                </dt>
                <dd class="content-data">
                  {{ container.week }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.load_date") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(container.load_date) }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.provider") }}
                </dt>
                <dd class="content-data">
                  {{ container.provider_names.join(", ") }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.packing_house") }}
                </dt>
                <dd class="content-data">
                  {{ container.packing_house_names.join(", ") }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <dt class="label-data">
                  {{ $t("model.container_final_quality.status") }}
                </dt>
                <dd class="content-data">
                  <container-final-quality-status
                    :status_id="container.container_final_quality?.status_id"
                  />
                </dd>
              </div>

              <div class="sm:col-span-6">
                <dt class="label-data">
                  {{ $t("model.container_final_quality.comments") }}
                </dt>
                <dd class="content-data">
                  {{ container.container_final_quality?.comments }}
                </dd>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/production/query_container_quality/show_container.js";
import ContainerFinalQualityStatus from "@/components/views/agro_exporter/production/shared/container/ContainerFinalQualityStatus.vue";
export default {
  name: "AEProductionQueryContainerExportShowContainer",
  components: { ContainerFinalQualityStatus },
  props: ["agro_exporter_process_id", "container_id", "agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      agro_exporter_process: {},
      container: null
    };
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainer();
      this.load_general_data = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer(
        this.agro_exporter_id,
        this.container_id
      );

      this.container = response.data;
    }
  },
  created() {
    this.checkIfAuthenticated();
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.fetchData())
    );
  }
};
</script>
